import { type FC } from "react";

import { Spacing } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../shared/components";
import { UnderlinedTextLink } from "../../../shared/styles";

import { AvailabilityDetailsWrapper } from "./AvailabilityDetails.styles";
import { LensBestPracticesLinkText, NotAvailableForAds } from "./messages.generated";

const DOCS_URL = "https://docs.snap.com/lens-studio/publishing/optimization/performance-optimization-guide";

export const AvailabilityDetails: FC = () => {
    return (
        <AvailabilityDetailsWrapper>
            <NotAvailableForAds />
            <Flexbox gap={`${Spacing.SM}px`}>
                <UnderlinedTextLink href={DOCS_URL} target="_blank" rel="noopener noreferrer">
                    <LensBestPracticesLinkText />
                </UnderlinedTextLink>
            </Flexbox>
        </AvailabilityDetailsWrapper>
    );
};
